module.exports = __webpack_public_path__ + "static/img/sign.44b9904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sign.png
// module id = ltXK
// module chunks = 1